
import {PLATFORM} from '../constant/actionTypes';

export default (state, action) => {
    switch (action.type) {
        case PLATFORM.DATA.INITIATE:
            return {isFetching: true, data: action.payload};
        case PLATFORM.DATA.SUCCESS:
            return {isFetching: false, data: action.payload};
        case PLATFORM.DATA.ERROR:
            return {isFetching: false, data: action.payload};
        default:
            return state ? state : [];
    }
};
